import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { Layout } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { subscribeNewsletter } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try { const r = await subscribeNewsletter(email); toast.success(r.message); setEmail(""); }
    catch { toast.error("Something went wrong."); }
    finally { setLoading(false); }
  };

  return (
    <Layout>
      <Seo
        title="SCMBrain Newsletter | Weekly Supply Chain Intelligence"
        description="One email a week. Supply chain planning frameworks, tools, and analysis for practitioners who want to stay ahead."
        path="/newsletter"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Newsletter</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B] leading-tight">
          Supply chain intelligence, every week.
        </h1>
        <p className="mt-5 text-lg text-[#3E577A]">
          One email. Frameworks, tools, and analysis for practitioners who want to stay ahead.
        </p>

        <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <Input data-testid="newsletter-email-input" aria-label="Email address" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="bg-white" />
          <button data-testid="newsletter-subscribe-btn" disabled={loading}
            className="bg-[#1A6B5A] text-white hover:bg-[#135245] transition-colors rounded-sm px-6 py-3 font-semibold disabled:opacity-60 whitespace-nowrap">
            {loading ? "Subscribing…" : "Subscribe Free"}
          </button>
        </form>
        <p className="mt-4 text-xs text-[#3E577A] flex items-center justify-center gap-1">
          <Check className="h-3.5 w-3.5 text-[#1A6B5A]" /> No spam. Unsubscribe anytime.
        </p>

        <div className="mt-16 grid sm:grid-cols-3 gap-6 text-left">
          {[
            { t: "Frameworks", d: "Battle-tested planning frameworks distilled into one-pagers." },
            { t: "Tools", d: "New calculators and templates as we release them." },
            { t: "Analysis", d: "Sharp takes on what's actually changing in SCM." },
          ].map((c) => (
            <div key={c.t} className="bg-[#F4F4F4] border border-[#E5E7EB] rounded-sm p-6">
              <h3 className="font-heading font-bold text-[#1B3A6B]">{c.t}</h3>
              <p className="text-sm text-[#3E577A] mt-2">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
